import axios from 'axios';
import Settings from './config';

export default {
    getConfiguration(cb) {
        axios.get('/umbraco/api/stay/getConfiguration')
            .then(response => {
              
                cb(response.data);
            });
    },
    search(sessionId, search, cb) {
        axios.post(Settings.ENDPOINT + 'api/stay/' + sessionId + '/availability' , search)
            .then(response => {
                cb(response.data);
            });
    },
    fetchCalendar(sessionId, search, cb) {
        axios.post(Settings.ENDPOINT + 'api/stay/' + sessionId + '/availability/calendar', search)
            .then(response => {
                cb(response.data);
            });
    },
    fetchPackages(search, cb) {
        axios.post(Settings.ENDPOINT + 'api/stay/packages', search)
            .then(response =>  {
                cb(response.data);
            });
    },
    sendBooking(sessionId, booking, cb, fcb) {
        axios.post(Settings.ENDPOINT + 'api/stay/' + sessionId + '/booking', booking)
            .then(response => {
                cb(response.data);
            }).catch(response => {
                fcb(response);
            });

    },
    ignoreBooking(payload, cb) {
        axios.post(Settings.ENDPOINT + 'api/stay/ignore', payload)
            .then(response => {
                cb(response.data);
            });

    },
    keepAlive(payload, cb, cbe) {
        axios.post(Settings.ENDPOINT + 'api/stay/keep-alive', payload)
            .then(response => {
                cb(response.data);
            }).catch(response => {
                cbe(response.data);
            });

    },

    stageBooking(sessionId, booking, cb) {
        axios.post(Settings.ENDPOINT + 'api/stay/' + sessionId + '/booking/stage', booking)
            .then(response => {
                cb(response.data);
            });

    },

    completeBooking(sessionId, payment, cb, cbe) {
        axios.post(Settings.ENDPOINT + 'api/stay/' + sessionId + '/booking/complete', payment)
            .then(response => {
                cb(response.data);
            }).catch(response => {
                cbe(response.data);
            });

    },

    fetchBookings(cb) {

        axios.get(Settings.ENDPOINT + 'api/stay/user-bookings')
            .then(response => {
                cb(response.data);
            });
    },
    getBooking(id ,cb) {

        axios.get(Settings.ENDPOINT + 'api/stay/retrieve/' + id)
            .then(response => {
                cb(response.data);
            });
    },
    cancelBooking(payload, cb) {
        axios.post(Settings.ENDPOINT + 'api/stay/cancel/', payload)
            .then(response => {
                cb(response.data);
            });
    },
    removePackage(payload, cb) {
        axios.post(Settings.ENDPOINT + 'api/stay/remove-package/', payload)
            .then(response => {
                cb(response.data);
            });
    },
    addPackage(payload, cb) {
        axios.post(Settings.ENDPOINT + 'api/stay/add-package/', payload)
            .then(response => {
                cb(response.data);
            });
    },
    addDiningPackage(payload, cb) {
        axios.post(Settings.ENDPOINT + 'api/stay/add-dining-package/', payload)
            .then(response => {
                cb(response.data);
            });
    },
    addSpaTreatmentPackage(payload, cb, fcg) {
        axios.post(Settings.ENDPOINT + 'api/stay/add-spa-treatment-package/', payload)
            .then(response => {
                cb(response.data);
            })
            .catch(response => {
                fcb(response);
            })
    },

    addSpaGardenPackage(payload, cb, fcg) {
        axios.post(Settings.ENDPOINT + 'api/stay/add-spa-garden-package/', payload)
            .then(response => {
                cb(response.data);
            })
            .catch(response => {
                fcb(response);
            })
    },

    addSpaMudPackage(payload, cb, fcg) {
        axios.post(Settings.ENDPOINT + 'api/stay/add-spa-mud-package/', payload)
            .then(response => {
                cb(response.data);
            })
            .catch(response => {
                fcb(response);
            })
    },


    sendEmail(payload, cb, fcb) {
        axios.post(Settings.ENDPOINT + 'api/stay/send-email/', payload)
            .then(response => {
                cb(response.data);
            }).catch(response => {
                fcb();
            });
    }




}

